// import { ResumoPropostaResponse } from 'src/types'
// : ResumoPropostaResponse
function informarcaoAlert(item) {
  const itemCentroAmbulatorial =
    item?.centroCirurgicoAmbulatorial ||
    item?.propostaCentroCirurgicoAmbulatorial
  const itemBaixoFluxo = item?.baixoFluxo || item?.propostaBaixoFluxo
  const itemDiasUteis =
    item?.diasUteis || item?.propostaDiasUteis || !itemBaixoFluxo

  var msgCartao = item?.cartaoDesconto
    ? 'Para pacientes com cartão de desconto. '
    : ''
  if (itemCentroAmbulatorial && itemDiasUteis) {
    return (
      msgCartao +
      'Para realização em qualquer dia e horário da semana no centro cirúrgico ambulatorial.'
    )
  } else if (itemCentroAmbulatorial && itemBaixoFluxo) {
    return (
      msgCartao +
      'Para realização em Horários de baixo fluxo no centro cirúrgico ambulatorial.'
    )
  } else if (!itemCentroAmbulatorial && itemDiasUteis) {
    return (
      msgCartao +
      'Para realização em qualquer dia e horário da semana no centro cirúrgico.'
    )
  } else if (!itemCentroAmbulatorial && itemBaixoFluxo) {
    return (
      msgCartao +
      'Para realização em Horários de baixo fluxo no centro cirúrgico.'
    )
  } else if (!itemCentroAmbulatorial && !itemDiasUteis && !itemBaixoFluxo) {
    return (
      msgCartao +
      'Para realização em qualquer dia e horário no centro cirúrgico.'
    )
  } else {
    return msgCartao + 'Informação não disponível.'
  }
}

export default informarcaoAlert
